import apiClient from "../apiClient";

export const WorkLocationsAPI = {
  getAll: () => apiClient.get("/api/v1/work-locations"),
  getAllPaginated: (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        searchParams.append(key, String(value));
      }
    });
    return apiClient.get(
      `/api/v1/work-locations/list?${searchParams.toString()}`
    );
  },
  getById: (id) => apiClient.get(`/api/v1/work-locations/list/${id}`),
  create: (payload) => apiClient.post(`/api/v1/work-locations`, payload),
  update: ({ id, payload }) =>
    apiClient.put(`/api/v1/work-locations/${id}`, payload),
  delete: (id) => apiClient.delete(`/api/v1/work-locations/${id}`),
};
